module.exports = __webpack_public_path__ + "media/src/images/icons/blogger_logo-60acd980d3db3e7dab9a879bfc533caa.svg";